<perfect-scrollbar class="scrollbar" [config]="perfectScrollbarConfig">
    <div class="h-100 position-relative p-4 scrollbar-content">
        <dp-sre-gantt-columns class="element"></dp-sre-gantt-columns>
        <dp-sre-gantt-values class="element mt-4"></dp-sre-gantt-values>
    </div>
</perfect-scrollbar>
